<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import {MessageStore} from "../../../../../store/MessageStore";
    import {UrlUtil} from "../../../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../../../lib/Common/Http/HttpRequestUtil";
    import {SpaceUserTable} from "../../../../../lib/Table/SpaceUserTable";
    import FontAwesomeView from "../../../../../component/common/Image/FontAwesomeView.svelte";
    import CreatedUpdatedView from "../../../../../component/common/Value/CreatedUpdatedView.svelte";
    import BadgeView from "../../../../../component/common/Value/BadgeView.svelte";

    const dispatcher = createEventDispatcher();

    export let space;
    export let spaceUser;

    $: canEdit = (() => {
        if (spaceUser == null) {
            return false;
        }


        if (spaceUser.authority_type === SpaceUserTable.AuthorityType.Manage) {
            return false;
        }
        return true;
    })();

    $: canDelete = (() => {
        if (spaceUser == null) {
            return false;
        }


        if (spaceUser.authority_type === SpaceUserTable.AuthorityType.Manage) {
            return false;
        }
        return true;
    })();

    onMount(() => {
    });

    function onClickEdit() {
        if (!canEdit) {
            return;
        }
        dispatcher('edit', {spaceUser: spaceUser});

    }

    function onClickDelete() {
        if (!canDelete) {
            return;
        }
        MessageStore.showConfirmInformationOKCancel("削除してもよいですか？", () => {
            const paramMap = {};
            paramMap['space_id'] = space.id;
            paramMap['id'] = spaceUser.id;
            const url = UrlUtil.createApiUrl("space_user");

            HttpRequestUtil.deleteRequest(url, paramMap, (response) => {

                console.log(response);
                const body = response['body'];

                dispatcher('update');

            });

        });

    }


</script>

<tr class="space-user-row-view">
    <td>
        {#if spaceUser.authority_type === SpaceUserTable.AuthorityType.Manage}
            <BadgeView label="管理者" isBorder={true} type="success"
                       hoverTipsMessage="管理者のため、編集したい場合はサービス管理者に問い合わせてください"/>
        {:else}
            {#if canEdit}
                <span class="edit-button icon-button" on:click={onClickEdit}>
                    <FontAwesomeView icon="edit"/>
                </span>
            {/if}
        {/if}
    </td>
    <td>{spaceUser.user_email}</td>
    <td>
        {#if spaceUser.user}
            {#if spaceUser.user.company_name}
                {spaceUser.user.company_name}
                <br/>
            {/if}
            {#if spaceUser.user.department_name}
                {spaceUser.user.department_name}
                <br/>
            {/if}
            {spaceUser.user.name}
        {:else}
            <span class="unregistered">未ログイン</span>
        {/if}
    </td>
    <td>{ SpaceUserTable.AuthorityType.map[spaceUser.authority_type]}</td>
    <td>
        <CreatedUpdatedView model={spaceUser}/>
    </td>
    <td>
        {#if canDelete}
            <span class="trash-button icon-button" on:click={onClickDelete}>
                <FontAwesomeView icon="trash"/>
            </span>
        {/if}
    </td>
</tr>
<style lang="scss">
    .space-user-row-view {
        .unregistered {
            opacity: 0.5; /* 文字を薄くする */
        }
    }
</style>
